import React, { useContext, ReactNode } from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';

import SubNavigation from 'components/SubNavigation/SubNavigation';
import Engagement from './Social';
import ShortFormVideo from './ShortFormVideo';

import { socialSubTopics } from 'topics';
import TopicFilters from 'components/TopicFilters/TopicFilters';
import { EntityContext } from 'context/entityContext';

const Social: React.FC<any> = (props) => {
  const { match, pathPrefix } = props;
  const { entityId } = match.params;

  const { compareMode, topic } = useContext(EntityContext);

  return (
    <>
      <SubNavigation topic="social" variants={socialSubTopics} />
      <TopicFilters topic={topic[1] || topic[0]} compareMode={compareMode} />
      <Switch>
        <Route
          exact
          path={`${pathPrefix}/track/${entityId}/social/engagement`}
          render={(): ReactNode => <Engagement />}
        />
        <Route
          exact
          path={`${pathPrefix}/track/${entityId}/social/shortFormVideo`}
          render={(): ReactNode => <ShortFormVideo />}
        />
        <Redirect
          exact
          from={`${pathPrefix}/track/${entityId}/social/linkfire`}
          to={`${pathPrefix}/track/${entityId}/social/engagement`}
        />
      </Switch>
    </>
  );
};

export default Social;
